// extracted by mini-css-extract-plugin
module.exports = {"headerTab":"kRJF7","highlighter":"X3ByM","tabList":"s18qU","active":"vQjBO","hide":"HxrRY","moreMenuDots":"iaxys","dots":"A_xLk","moreMenuItems":"U8hAB"};